import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  let isAuthenticated = false;
  try {
    const session = sessionStorage.getItem("aman-admin");
    if (session) {
      const parsed = JSON.parse(session);
      if (parsed && parsed.admin) {
        isAuthenticated = true;
      }
    }
  } catch (e) {
    isAuthenticated = false;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;
